// Back-compat redirect for the retired /ask-ai routes. The page was renamed to
// the AI Playground (/ai-playground, /ai-playground/history), but published KB
// articles, bookmarks and links shared before the rename still point at the old
// paths — so those keep resolving here instead of falling through to the
// catch-all "* → /".
//
// The query string is carried over deliberately: /ask-ai/history?runId= is the
// run-audit deep link used by the inbox, playbook runs and the audit redirect.

import { Navigate, useLocation } from 'react-router-dom';

export function LegacyAskAiRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}

export default LegacyAskAiRedirect;
